import requester from 'utils/requester';

const MAX_CONNECTION_CHECK_TIME_MS = 2 * 60 * 1000;

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms || 0));

export const checkConnection = async (startTimestamp = Date.now()) => {
  if (Date.now() - startTimestamp > MAX_CONNECTION_CHECK_TIME_MS) return false;
  try {
    await requester({
      method: 'get',
      url: 'https://smart.ott.volia.com:8081/',
    });
    return true;
  } catch (_) {
    await wait(1000);
    return checkConnection(startTimestamp);
  }
};
